export function formatINR(n) {
  if (n == null || isNaN(n)) return "₹0";
  const abs = Math.abs(n);
  if (abs >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  if (abs >= 1e3) return `₹${(n / 1e3).toFixed(1)}K`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}

export function formatNum(n) {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString("en-IN");
}

export const STATUS_STYLES = {
  green: {
    label: "On Track",
    card: "bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-950/40 dark:border-emerald-800/50 dark:text-emerald-300",
    dot: "bg-emerald-500",
    badge: "bg-emerald-500 text-white",
  },
  amber: {
    label: "At Risk",
    card: "bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950/40 dark:border-amber-800/50 dark:text-amber-300",
    dot: "bg-amber-500",
    badge: "bg-amber-500 text-white",
  },
  red: {
    label: "Critical",
    card: "bg-rose-50 border-rose-200 text-rose-800 dark:bg-rose-950/40 dark:border-rose-800/50 dark:text-rose-300",
    dot: "bg-rose-500",
    badge: "bg-rose-600 text-white",
  },
};

export const CHART_COLORS = ["#0D9488", "#E11D48", "#0284C7", "#D97706", "#8B5CF6", "#10B981"];
